import {PaymentError} from '@/features/guest-payments/types'
import {TagManager} from '@/integrations/tag-manager/tagManager'
import {ROUTE_MESSAGE_CENTER} from '@/utilities/constants/routeNames'
import {LocalStorageManager} from '@/utilities/localStorage'
import {useMutation} from '@tanstack/react-query'
import {buyMicromorgiPackageV3} from '../services/micromorgi.http'
import {BuyMicromorgiPackageParamsV3, PaymentUrls} from '../types'
import {MUTATION_KEYS} from './keys'
import {Message} from '@/features/common/types'

export const useBuyMicromorgiPackageV3 = () => {
    return useMutation<PaymentUrls | Message, PaymentError, BuyMicromorgiPackageParamsV3>({
        mutationKey: [MUTATION_KEYS.buyMicromorgiPackageV3],
        mutationFn: buyMicromorgiPackageV3,
        onSuccess: data => {
            if ('transaction_id' in data && 'transaction_amount' in data) {
                TagManager.dataLayer({
                    event: 'purchase',
                    transactionId: data.transaction_id,
                    transactionAmount: +data.transaction_amount
                })
            }
        },
        onSettled: () => {
            LocalStorageManager.paymentStartLocation.set(location.pathname ?? ROUTE_MESSAGE_CENTER)
        }
    })
}
